import VideoServiceBase_1 from '../../node_modules/markdown-it-block-embed/lib/services/VideoServiceBase.js';
import { canUseDOM } from '../../utils/markdown.plugin.utils.js';

// TwitchService is tested in BlockEmbed.test.js
class TwitchService extends VideoServiceBase_1 {
  extractVideoID(reference) {
    let match = reference.match(/^.*twitch.tv\/(videos?\/)?(.[^/]+)/);
    if (match) {
      // Twitch video urls are of format twitch.tv/videos/[VIDEO_ID]
      if (match[1] === 'videos/') return "video=".concat(match[2]);
      // Twitch channel urls are of format twitch.tv/[CHANNEL_ID]
      if (!match[1]) return "channel=".concat(match[2]);
    }
    return reference;
  }
  getVideoUrl(videoID) {
    let escapedVideoID = this.env.md.utils.escapeHtml(videoID);
    let locationHostname = canUseDOM ? location.hostname : '';
    return "//player.twitch.tv/?".concat(escapedVideoID, "&autoplay=false&parent=").concat(locationHostname);
  }
}
var TwitchService$1 = TwitchService;

export { TwitchService$1 as default };
